import EventStatus from '@/league/components/schedule/EventStatus';
import ImageComponent from '@/components/base-components/ImageComponent';
import EventButton from '@/league/components/main/EventButton';
import {mapState} from 'vuex';
import {EVENT_TYPE, LONG_GENDERS_NAMES, MEDIA_TYPE, SHORT_GENDERS_NAMES} from '@/const';
import SportIcons from '../../../assets/img/SportIcons';
import FavoriteStarDisplay from '@/components/favorites/FavoriteStarDisplay';
import AccountLock from '@/assets/img/AccountLock.vue';
import {SELECT_PACKAGE, WATCH} from '@/pages';
import {eventTeams, eventTimeObject, eventTitle} from '@/league/components/EventCards/eventMethods';

export default {
  name: 'CWEventCard',
  components: {
    AccountLock,
    FavoriteStarDisplay,
    SportIcons,
    EventButton,
    ImageComponent,
    EventStatus,
  },
  props: {
    event: {
      type: Object,
      time_zone: String,
      event_utc_ts: Number,
    },
  },
  computed: {
    ...mapState({
      eventCategories: (state) => state.event.eventCategoriesById,
    }),
    message() {
      return this.event.caption;
    },
    isPlayOff() {
      return this.event.is_playoff;
    },
    venue() {
      return this.event.venue;
    },
    sport() {
      return this.eventCategories[this.event.event_category_id];
    },
    teams() {
      return eventTeams(this.event);
    },
    time() {
      return eventTimeObject(this.event);
    },
    eventTime() {
      return `${this.time.month} ${this.time.day} ${this.time.hh} ${this.time.zone}`;
    },
    eventPoster() {
      return this.event.media?.find((media) => media.media_type === MEDIA_TYPE.image)?.media_url;
    },
    gender() {
      return SHORT_GENDERS_NAMES[this.teams?.homeTeam?.gender?.toLowerCase()];
    },
    fullGender() {
      return LONG_GENDERS_NAMES[this.teams?.homeTeam?.gender?.toLowerCase()];
    },
    cardBodyStyle() {
      if (this.event.participants.length === 2) {
        const c1 = this.teams.homeTeam.color;
        const c2 = this.teams.awayTeam.color;
        return {
          background: `linear-gradient(-55deg, ${c1} 0% , ${c1} 50% , ${c2} 50% )`,
        };
      }
      return null;
    },
    title() {
      return eventTitle(this.event);
    },
    hasAccess() {
      return this.event.has_access;
    },
    path() {
      if (this.event.has_access) {
        return {
          name: WATCH.name,
          params: {id: this.event.id},
        };
      }
      if (!this.event.has_access && this.event.type === EVENT_TYPE.register) {
        return {
          ...SELECT_PACKAGE,
          params: {
            id: this.event.id,
          },
        };
      }
      return {
        name: SELECT_PACKAGE.name,
        params: {
          id: this.event.id,
        },
        query: {
          single_event_package_id: this.$route.query?.package_id,
        },
      };
    },
    isTwoParticipant() {
      return this.event.participants.length === 2;
    },
  },
};
